import { useRef } from 'react';

const DEFAULT_OFFSET = 160;

export const useScrollIntoView = (offset?: number) => {
	const ref = useRef<HTMLDivElement>(null);

	const scrollIntoView = () => {
		if (ref?.current) {
			const rect = ref.current.getBoundingClientRect();

			window.scrollBy({
				// UX Adjustment - Adjust the scroll to leave whitespace
				top: rect.top - (offset || DEFAULT_OFFSET),
				behavior: 'smooth',
			});
		}
	};

	return { ref, scrollIntoView };
};
